import { Button, Label } from "@inkblot-therapy/squid"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
export const SubmitError = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="flex flex-col h-[100vh] mt-28 items-center max-w-2xl mx-auto">
      <div className="pb-[56px] flex flex-col">
        <div>
          <Label
            strong={false}
            className="text-[color:var(--core-color-slate-90)] [font-family:var(--alias-font-display-xl-font-family)] [font-size:var(--alias-font-display-xl-font-size)]"
          >
            {t("client.submission.error.title")}
          </Label>
        </div>
      </div>
      <div className="w-full flex gap-4 justify-end">
        <Button onClick={() => navigate("/ontario/upload")} variant="primary">
          {t("client.submission.error.button")}
        </Button>
      </div>
    </div>
  )
}
